<template>
  <div class="activeAnimate fb fb-col">
    <div class="innerCircle fb" :class="boxStyle">
      <i class="iconfont deviceIcon">&#xe695;</i>
    </div>
    <div class="font-40">
      <p v-show="componentStatus === 1" class="activeText">设备激活中</p>
      <div v-show="componentStatus === 0" class="activeText activeSuccess">
        <!-- <span class="item-self-center">激活成功</span> -->
        激活成功
      </div>
      <div v-show="componentStatus === 2" class="activeText activeFaile"
        >设备激活失败</div
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    componentStatus: {
      type: Number,
      default: 1
    }
  },
  computed: {
    boxStyle() {
      let _style = ''
      switch (this.componentStatus) {
        case 1:
          _style = 'middleBox'
          break
        case 2:
          _style = 'faileBox'
          break
        default:
          _style = 'successBox'
          break
      }
      return _style
    },
    iconStyle() {
      return this.componentStatus === 2 ? 'icon-device-fail' : 'icon-activation'
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>
.activeAnimate {
  width: 100vw;
  height: 100vh;
  text-align: center;
}
.middleBox::after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 50%;
  opacity: 0;
  animation: ripple 1.8s ease-out 0.9s infinite;
}
.middleBox::before {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 50%;
  opacity: 0;
  animation: ripple 1.8s ease-out 225ms infinite;
}
.innerCircle {
  width: 30vw;
  height: 30vw;
  border-radius: 50%;
  margin-top: 25vh;
  background-color: #38adff;
  color: #fff;
  align-items: center;
  align-self: center;
  justify-content: center;
  text-align: center;
  position: relative;
}
.deviceIcon {
  color: #fff;
  font-size: 15vw !important;
}
.activeText {
  align-self: center;
  margin-top: 20vw;
  font-family: 'PingFangSC-Regular';
}
.activeFaile {
  color: #333;
  margin-top: 10vw;
}
.faileBox {
  background-color: #cdcdcd;
}
.successIcon {
  display: inline-block;
}
.activeSuccess {
  /* display: flex; */
  margin-top: 10vw;
}
@keyframes ripple {
  0% {
    opacity: 0;
    -webkit-transform: scale(1);
  }

  5% {
    opacity: 0.8;
    -webkit-transform: scale(1.2);
  }
  to {
    opacity: 0;
    -webkit-transform: scale(2.5);
    background-color: #38adff;
  }
}
</style>
